'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findRoute = undefined;

var _Home = require('./pages/Home');

var _Home2 = _interopRequireDefault(_Home);

var _User = require('./pages/User');

var _User2 = _interopRequireDefault(_User);

var _Users = require('./pages/Users');

var _Users2 = _interopRequireDefault(_Users);

var _Dummy = require('./pages/Dummy');

var _Dummy2 = _interopRequireDefault(_Dummy);

var _ToyList = require('./pages/ToyList');

var _ToyList2 = _interopRequireDefault(_ToyList);

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// DRY'd here to allow normal <Route> config and allow proper action deduction from a single config
var routes = [{ path: '/', component: _Home2.default, exact: true }, { path: '/jobs', component: _Dummy2.default }, { path: '/members', component: _Users2.default }, { path: '/lists/toy', component: _ToyList2.default }, { path: '/search', component: _Dummy2.default }, { path: '/settings', component: _Dummy2.default }, { path: '/notifications', component: _Dummy2.default }, { path: '/users/:id', component: _User2.default }, { path: '/:username', component: _User2.default }, { component: _Dummy2.default }];

var findRoute = exports.findRoute = function findRoute(pathname) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = routes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var route = _step.value;

      var match = (0, _reactRouterDom.matchPath)(pathname, route);
      if (match) {
        return { match: match, route: route };
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  throw new Error('missing route'); // this should not be possible - the last route is expected to catch all fallthrough
};

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ./js/routes.js
// module id = 170
// module chunks = 177